import { Component, Vue, Prop as prop, Prop} from 'nuxt-property-decorator';

@Component({
    components: {
        itemComponent: require("../configurator-text-row-item/index.vue").default
    }
})
export default class ConfiguratorImageRow extends Vue {

    @Prop() option;
    @Prop() current;
    @Prop() matchedOffers;
}
